'use strict';

angular.module('licensure.services')
    .factory('Triggers', ['$http', '$q', function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/triggers', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                        d.resolve(null);
                    });

                return d.promise;
            },
            
            getForFormCondition: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/triggers/getForFormCondition', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                        d.resolve(null);
                    });


                return d.promise;
            },

            fire: function (args) {
                var d = $q.defer();

                $http.post(apiLocation + '/api/triggers/fire', args)
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                        d.resolve(null);
                    });

                return d.promise;
            }
        }
    }])
;